function Lobby() {

    var lobbyFlasfUrl, lobbyFlasfWidth, tourneyLobbyFlashUrl, lobbyFlasfHeight,
        sessionId, resizable = 0, scrollbars = 0, testLoginUrl, notLoggedUrl;

    Lobby.prototype.init = function (_lobbyUrl, _tourneyUrl, _sessionId, _width,
        _height, _resizable, _scrollbars, _testLoginUrl, _notLoggedUrl) {
        lobbyFlasfUrl = _lobbyUrl;
        tourneyLobbyFlashUrl = _tourneyUrl;
        lobbyFlasfHeight = _height;
        lobbyFlasfWidth = _width;
        sessionId = _sessionId;
        resizable = _resizable;
        scrollbars = _scrollbars;
        notLoggedUrl = (_notLoggedUrl && _notLoggedUrl != '') ? _notLoggedUrl : '/login.html?reason=login_error';
        testLoginUrl = (_testLoginUrl && _testLoginUrl != '') ? _testLoginUrl : '/testxml/casino/index';
    }, Lobby.prototype.openGameWindow = function (_id, url, params) {
        var gameWin;
        try {
            var winName = 'a_' + sessionId.replace(/-/g, '_') + '_' +
                _id.replace(/[^\w]/g, '_');

            //gameWin = window.open("", winName, params);
            //if (! gameWin || ! gameWin.document.getElementById('flash_container')) {

            if (authWindow) {
                //alert(url);
                //gameWin = window.open(url, winName, params);
                authWindow.location.replace(url);
            }
            if (gameWin) gameWin.focus();
        } catch (e) {
        }
        return gameWin;
    }, Lobby.prototype.openPokerLobby = function () {
        return this.openGameWindow("PokerLobby", lobbyFlasfUrl, "width=" +
            lobbyFlasfWidth + ",height=" + lobbyFlasfHeight +
            ",menubar=0,toolbar=0,status=0,resizable=" + resizable +
            ",scrollbars=" + scrollbars + ",fullscreen=0");
    }, Lobby.prototype.openTournamentLobby = function (tournamentId) {
        return this.openGameWindow(tournamentId, tourneyLobbyFlashUrl +
            "?TOURNAMENTID=" + tournamentId, "width=" +
            lobbyFlasfWidth + ",height=" + lobbyFlasfHeight +
            ",menubar=0,toolbar=0,status=0,resizable=" + resizable +
            ",scrollbars=" + scrollbars + ",fullscreen=0");
    }, Lobby.prototype.checkUserSessionAndOpenHistoryWin = function (tournamentId) {
        var instance = this;
        $.ajax({
            url: testLoginUrl,
            cache: false,
            async: false,
            dataType: 'xml',
            success: function (data) {
                var $dom = $(data);
                if ($dom.find('LOGGEDIN').length > 0) {
                    instance.openTournamentLobby(tournamentId);
                } else {
                    window.location = '/login';
                }
            }
        });
    }, Lobby.prototype.checkUserSessionAndOpenWin = function () {
        authWindow = window.open('about:blank', '', 'left=20,top=20,width=800,height=600,toolbar=0,resizable=1');
        var instance = this;
        $.ajax({
            url: testLoginUrl,
            cache: false,
            async: false,
            dataType: 'xml',
            success: function (data) {
                var $dom = $(data);
                console.log(data);
                if ($dom.find('LOGGEDIN').length > 0) {
                    instance.openPokerLobby();
                } else {
                    window.location = notLoggedUrl;
                    authWindow.location.replace(notLoggedUrl);
                    authWindow.close();
                }
            },
            error: function (a, b, c) {
                alert(c + "yes22")
            }
        });
    }
}

var lobby = new Lobby();

if (window.com == null) {
    window.com = {};
}
if (window.com.intrice == null) {
    window.com.intrice = {};
}

document.getOpencmsObject = function (objName) {
    if ('opencms' in document && objName in document['opencms']) {
        return document['opencms'][objName];
    }
    return {};
};

function getImgCards(cards) {
    try {
        var cardsList = cards.split(' ');
        for (var i in cardsList) {
            if (cardsList[i].length == 2 && typeof (cardsList[i]) == 'string') {
                document.write('<img src="/i/cards/' + cardsList[i] + '.png" alt="' + cardsList[i] + '"/>');
            }
        }
    } catch (e) {
    }
}

function getImgCardsForSlides(place, cards) {
    try {
        var cardsList = cards.split(' ');
        var id = '#' + place;
        for (var i in cardsList) {
            if (cardsList[i].length == 2 && typeof (cardsList[i]) == 'string') {
                if ($(id + "> img:first").hasClass(cardsList[i])) {
                    break
                }
                $(id).append('<img src="/i/cards/' + cardsList[i] + '.png" alt="' + cardsList[i] + '" class="' + cardsList[i] + '"/>');
            }
        }
    } catch (e) {
    }
}

function getMultiplyValue(val) {
    try {
        var str = val;
        if (val.indexOf(':') > 0) {
            str = val.substring(0, val.indexOf(':') + 1) + " ";
            var num = parseFloat(val.substring(val.indexOf(':') + 1, val.indexOf('(')));
            num *= 100;
            str += num;
            str += " " + val.substring(val.indexOf('('), val.length);
        }
        document.write(str);
    } catch (e) {
    }
}